/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useMemo } from 'react';
import RadioGroup from '../../../../../components/form/elements/radio-group';
import InputDate from '../../../../../components/form/elements/date';
import TextArea from '../../../../../components/form/elements/text-area';
import { useService } from '../../../../../services/services';
import { useTranslation } from 'react-i18next';
import StatusEnum from '../enums/event-status';
import Group from '../../../../../components/form/elements/group';
import CustomTable from './custom-table';
import File from '../../../../../components/form/elements/file';
import { FormComponent } from '../../../../../components/form';
import { CalendarImage } from '../../../../../assets/icons/insex';
import Watch from '../../../../../components/form/elements/watch';

function useFormBody(): FormComponent[] {
  const { animalEventService } = useService();
  const { t } = useTranslation();

  const transKeyPrefix = 'pages.livestock.animals_and_events.';
  const tp = useCallback(
    (key: string, params?: any) => t(transKeyPrefix.concat(key), params),
    [t]
  );

  function calculateAnimalAge(birthDateStr, otherDateStr) {
    let birthDate = new Date(birthDateStr);
    let otherDate = new Date(otherDateStr);

    let years = otherDate.getFullYear() - birthDate.getFullYear();
    let months = otherDate.getMonth() - birthDate.getMonth();
    let days = otherDate.getDate() - birthDate.getDate();

    if (days < 0) {
      months--;
      days += new Date(
        otherDate.getFullYear(),
        otherDate.getMonth(),
        0
      ).getDate();
    }
    if (months < 0) {
      years--;
      months += 12;
    }

    return tp('events.weighing.age', {
      year: years,
      monthes: months,
      days: days,
    });
  }

  const FileUploadComponent = React.memo(({ ...rest }) => {
    const FileCom = useMemo(() => {
      return File(
        'file',
        null,
        false,
        animalEventService,
        true,
        transKeyPrefix.concat('animals.')
      );
    }, []);
    return (
      <div className="file_container" style={{ height: 'maxContent' }}>
        <FileCom {...rest} />
      </div>
    );
  });

  const NotesComponent = ({ ...rest }) => {
    const Notes = useMemo(() => {
      return TextArea(
        'notes',
        tp('events.notes'),
        undefined,
        false,
        undefined,
        true
      );
    }, []);
    return <Notes {...rest} />;
  };

  const body = useMemo(
    () => [
      (rest) => {
        const StatusGroup = RadioGroup(
          'status',
          [
            {
              label: tp('events.grazing.planned'),
              value: StatusEnum.planned,
            },
            {
              label: tp('events.grazing.completed'),
              value: StatusEnum.completed,
            },
          ],
          null,
          true
        );

        const DateInput = Watch(
          InputDate(
            'date',
            tp('events.date'),
            null,
            null,
            true,
            CalendarImage,
            true,
            true
          ),
          ({ getValues, setValue, value, trigger }) => {
            setValue(
              'weighingsAndAnimals',
              getValues('weighingsAndAnimals').map((animal) => ({
                ...animal,
                age_days_of_weighing: calculateAnimalAge(
                  animal.birth_date,
                  value
                ),
              }))
            );
            trigger('weighingsAndAnimals');
          }
        );

        return (
          <div className="max-w-[420px] form_body_top">
            <StatusGroup {...rest} />
            <DateInput {...rest} />
          </div>
        );
      },
      Group([CustomTable()], null),

      (rest) => {
        return (
          <div className="max-w-[420px] gap-[15px] flex flex-col">
            <NotesComponent {...rest} />

            <FileUploadComponent {...rest} />
          </div>
        );
      },
    ],
    []
  );

  return body;
}

export default useFormBody;
